import { useAppearance } from '@plug-core/state'
import React, { ReactNode, useEffect } from 'react'

/** Mirrors the persisted tone onto <html data-tone>. index.html applies it before first paint. */
export const AppearanceProvider = ({ children }: { children: ReactNode }) => {
  const tone = useAppearance((state) => state.tone)

  useEffect(() => {
    document.documentElement.dataset.tone = tone
    document.documentElement.dataset.theme = 'dark'
  }, [tone])

  return <>{children}</>
}
